/**
 * Carte KPI réutilisable (icône + couleur + animation légère au survol).
 */
import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";

const COLOR_MAP = {
  blue: { bg: "bg-blue-50", text: "text-[#0B5394]" },
  green: { bg: "bg-emerald-50", text: "text-emerald-600" },
  orange: { bg: "bg-amber-50", text: "text-amber-600" },
  red: { bg: "bg-red-50", text: "text-red-600" },
  slate: { bg: "bg-slate-100", text: "text-slate-600" },
};

export default function KpiCard({ testId, icon: Icon, label, value, suffix, subtext, color = "blue" }) {
  const c = COLOR_MAP[color] || COLOR_MAP.blue;
  return (
    <Card
      data-testid={testId}
      className="group border-slate-200 p-4 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md"
    >
      <div className="flex items-start justify-between">
        <div>
          <p className="text-xs font-semibold uppercase tracking-wider text-slate-500">{label}</p>
          <p className="mt-1.5 text-2xl font-bold tabular-nums text-slate-800">
            {value}
            {suffix && <span className="ml-1 text-sm font-medium text-slate-400">{suffix}</span>}
          </p>
          {subtext && <p className="mt-0.5 text-xs text-slate-400">{subtext}</p>}
        </div>
        <div
          className={cn(
            "flex h-10 w-10 shrink-0 items-center justify-center rounded-full transition-transform duration-200 group-hover:scale-110",
            c.bg
          )}
        >
          <Icon className={cn("h-5 w-5", c.text)} strokeWidth={1.5} />
        </div>
      </div>
    </Card>
  );
}
